<template>
  <v-textarea
    v-model="value"
    auto-grow
    :rules="field.rules"
    :disabled="field.disabled"
    :counter="field.counter"
    :clearable="!field.disabled && !field.required"
    :placeholder="field.placeholder || field.label"
    v-if="$vuetify.breakpoint.smAndUp"
  />
  <v-text-field
    v-else
    v-model="value"
    :rules="field.rules"
    :counter="field.counter"
    :disabled="field.disabled"
    :clearable="!field.disabled && !field.required"
    :placeholder="field.placeholder || field.label"
  />
</template>

<script>
import { fieldMixin } from '../../../mixins/fieldMixin'

export default {
  mixins: [fieldMixin]
}
</script>
